<nz-spin [nzSpinning]="(loading$ | async) || isLoadingUserData">
  <form [formGroup]="userForm" class="form">
    <div class="drawer-form-wrapper">
      <div class="form-grid-secondary">
        <nz-form-item>
          <nz-form-label nzFor="userName" nzRequired>Username</nz-form-label>
          <nz-form-control [nzErrorTip]="userNameError">
            <input
              name="email"
              type="text"
              nz-input
              id="email"
              formControlName="email"
              placeholder="Enter username" />
            <ng-template #userNameError let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter email address
              </ng-container>
              <ng-container *ngIf="control.hasError('email')">
                Please enter a valid email address
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="firstName" nzRequired>First Name</nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameError">
            <input
              name="firstName"
              type="text"
              nz-input
              id="firstName"
              formControlName="firstName"
              placeholder="Enter first name" />
            <ng-template #firstNameError let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter first name
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="lastName" nzRequired>Last Name</nz-form-label>
          <nz-form-control [nzErrorTip]="lastNameError">
            <input
              name="lastName"
              type="text"
              nz-input
              id="lastName"
              formControlName="lastName"
              placeholder="Enter last name" />
            <ng-template #lastNameError let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter last name
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="organizationId" nzRequired
            >User's School</nz-form-label
          >
          <nz-form-control [nzErrorTip]="schoolError">
            <nz-select
              formControlName="organizationId"
              nzShowSearch
              nzAllowClear
              nzMode="multiple"
              [nzShowArrow]="true"
              nzPlaceHolder="Select"
              [nzOptionOverflowSize]="7"
              (nzOnSearch)="onOrganizationSearch($event)"
              [nzServerSearch]="true">
              <nz-option
                *ngFor="let org of filteredOrganizations$ | async"
                [nzLabel]="org.organizationName || ''"
                [nzValue]="org.id">
              </nz-option>
            </nz-select>

            <ng-template #schoolError let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please select user's School
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="titleId" nzRequired>Title</nz-form-label>
          <nz-form-control [nzErrorTip]="titleError">
            <nz-select
              formControlName="titleId"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzShowArrow="true"
              nzPlaceHolder="Select"
              [nzOptionOverflowSize]="7"
              (ngModelChange)="onTitleChange($event)">
              <nz-option
                *ngFor="let title of titles$ | async"
                [nzLabel]="title.title"
                [nzValue]="title.id">
              </nz-option>
            </nz-select>
            <ng-template #titleError let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please select title
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="col-span">
          <nz-form-label nzFor="statusId" nzRequired>Status</nz-form-label>
          <nz-form-control nzErrorTip="Please select status">
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select a status"
              formControlName="statusId"
              name="statusId">
              @for (status of statusList; track status) {
                <nz-option
                  [nzLabel]="status.value | titlecase"
                  [nzValue]="status.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <h3 class="title s-18 mb-16">User Roles</h3>
      <p class="extra-text mb-16">
        If applicable, it is only necessary to select one of the following 3 CMS
        roles.
      </p>
      <nz-table
        #rowSelectionTable
        [nzData]="userDetails.roleList"
        [nzFrontPagination]="false"
        (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"
        nzShowPagination="false">
        <thead>
          <tr>
            <th
              scope="col"
              nzWidth="60px"
              [nzSelections]="listOfSelection"
              [(nzChecked)]="checked"
              [nzIndeterminate]="indeterminate"
              (nzCheckedChange)="onAllChecked($event)"></th>
            <th scope="col">User Roles</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of rowSelectionTable.data">
            <td
              [nzChecked]="setOfCheckedId.has(data.id)"
              (nzCheckedChange)="onItemChecked(data.id, $event)"></td>
            <td>
              {{ data.name }}
              <svg-icon
                *ngIf="getRoleDescription(data.name)"
                nz-tooltip
                [nzTooltipTitle]="getRoleDescription(data.name)"
                src="/assets/icon/icon-help.svg"
                class="icon s-12"
                aria-label="Help">
              </svg-icon>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div class="drawer-footer">
      <button nz-button type="button" nzType="default" (click)="onCancel()">
        Cancel
      </button>
      <button
        nz-button
        type="button"
        nzType="primary"
        [nzLoading]="isSubmitting"
        [disabled]="isSubmitting || userForm.invalid"
        (click)="onSubmit()">
        {{ formMode === 'CREATE' ? 'Add' : 'Save' }}
      </button>
    </div>
  </form>
</nz-spin>
